import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  CardDetail,
  FlatIconAndText2Row,
  NoteView,
  RowText
} from "../../../../../../component/index.jsx"
import {
  stringFormatting,
  convertDotToComma,
  convertM2ToHectare
} from "../../../../../helpers/TextHelper.js"
import { Card, Col, Row } from "react-bootstrap"
import { Skeleton } from "@material-ui/lab"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import {
  DATE_TYPE_ENUM,
  ROUTING_STATUS,
  UNIT_STRING
} from "../../../../../../constants/StringConstant.js"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { CardQaPhase } from "../../../../../../component/atoms/CardQaPhase/CardQaPhase.jsx"
import { PriviewMap } from "../../../../../../component/atoms/PriviewMap/index.jsx"
import { getBlockDetail } from "../../../../../../redux/actions/AreaAction.jsx"
import { useDispatch } from "react-redux"
import SVG from "react-inlinesvg"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"

export const BlockTab = ({ loading, data, id, status, history }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getBlockDetail(id))
  }, [])

  const mapInformationStyle = {
    position: "absolute",
    top: "100px",
    right: "58px",
    zIndex: "9",
    background: "#353535",
    borderRadius: "10px",
    padding: "24px 8px 8px 8px",
    cursor: "pointer"
  }

  const descriptionLeft = () => {
    return (
      <>
        <div className={"w-auto mr-2"}>
          <Row>
            <Col className={"mr-4 border-right"} md={"auto"}>{`${t(
              "label_no_doc"
            )} : ${stringFormatting(data.header?.doc_number)}`}</Col>
            <Col className={"mr-4 border-right"} md={"auto"}>{`${t(
              "label_no_file"
            )} : ${stringFormatting(data.header?.file_number)}`}</Col>
            <Col className={"mr-4"} md={"auto"}>{`${t("label_no_base")} : ${stringFormatting(
              data.header?.base_number
            )}`}</Col>
          </Row>
        </div>
        {loading ? (
          <>
            <Skeleton animation="wave" variant={"text"} width={250} />
            <Skeleton animation="wave" variant={"text"} width={200} />
          </>
        ) : (
          <>
            <span className="font-weight-bold text-dark-50">
              {stringFormatting(data.header?.sub_district_name) +
                " - " +
                stringFormatting(data.header?.district_name)}
            </span>
            <span className="font-weight-bold text-dark-50">
              {stringFormatting(data.header?.regency_name) +
                " - " +
                stringFormatting(data.header?.province_name)}
            </span>
            {loading ? (
              <Skeleton animation="wave" variant={"text"} width={250} height={50} />
            ) : data.header?.is_block_active ? (
              data.header?.is_block_has_land_clearing ? (
                <NoteView title={t("messages_alert_block_has_land_clearing")} className={"w-fit"} />
              ) : (
                <></>
              )
            ) : (
              <NoteView
                title={t("messages_title_non_active_block", {
                  date: `${timeStampToDate(data.header?.off_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)}`
                })}
                className={"w-fit"}
                variant={"info"}
              />
            )}
          </>
        )}
      </>
    )
  }

  const bottomIconAndText = () => {
    return (
      <Row className={"ml-0"}>
        <div className={"border-right mr-4"}>
          <FlatIconAndText2Row
            rounded={true}
            title={t("label_mitra_name")}
            svg={ICON_CONSTANTS.MITRA_2}
            description={stringFormatting(data.header?.mitra_name)}
          />
        </div>
        <div className={"border-right mr-4"}>
          <FlatIconAndText2Row
            rounded={true}
            title={t("label_block_area")}
            svg={ICON_CONSTANTS.BLOCK_AREA}
            description={
              data.header?.submitted_land_block === null
                ? "-"
                : convertDotToComma(convertM2ToHectare(data.header?.submitted_land_block, 4), UNIT_STRING.HA)
            }
          />
        </div>
        <div>
          <FlatIconAndText2Row
            rounded={true}
            title={t("label_total_land_pass")}
            svg={ICON_CONSTANTS.PASS_LAND}
            description={convertDotToComma(
              convertM2ToHectare(data.header?.total_land_pass, 4),
              `Ha`
            )}
          />
        </div>
      </Row>
    )
  }

  const blockDetail = () => {
    return (
      <RowModule>
        <CardDetail
          titleCardDetail={stringFormatting(data.header?.block_name)}
          descriptionLeft={descriptionLeft()}
          flatIconAndText2Rows={bottomIconAndText()}
          svgImage={ICON_CONSTANTS.SUB_REGIONAL_WHITE}
          iconBackground={"bg-primary"}
        />
      </RowModule>
    )
  }
  const rightComponent = () => {
    return (
      <div
        className={"w-full d-flex justify-content-end mr-2"}
        onClick={() =>
          history.push(
            RoutesConstants.AREA.DETAIL_QA_INSPECTION(
              status,
              id,
              data?.plant_info?.id_last_activity
            )
          )
        }>
        <div className={"text-primary font-weight-bolder txt-14 mr-2"}>
          {t("label_view_report")}
        </div>
        <SVG src={ICON_CONSTANTS.ARROW_RIGHT_GREEN} />
      </div>
    )
  }

  const plantInformation = () => {
    return (
      <Card className={"mb-4"}>
        <CardBody className={"h-auto"}>
          <h4 className={"mb-8 text-uppercase"}>
            {loading ? (
              <Skeleton animation={"wave"} variant={"text"} height={32} width={200} />
            ) : (
              t("label_plant_information")
            )}
          </h4>
          {data.plant_info?.last_activity_enum && (
            <CardQaPhase
              type={data.plant_info?.last_activity_enum}
              status={data.plant_info?.last_activity_status_enum}
              rightComponent={!data.plant_info?.is_old_data && rightComponent()}
            />
          )}
          <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
            <RowText
              label={t("label_plant_type")}
              value={stringFormatting(data.plant_info?.plant_type)}
            />
            <RowText
              label={
                status === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE
                  ? t("label_planting_male_date")
                  : t("label_planting_date")
              }
              value={timeStampToDate(
                data.plant_info?.male_planting_date,
                DATE_TYPE_ENUM.ISO_DATE_STRAP
              )}
            />
            <RowText
              label={t("label_plant_variety")}
              value={stringFormatting(data.plant_info?.variety)}
            />
            <RowText
              label={t("label_planting_female_date")}
              value={timeStampToDate(
                data.plant_info?.female_planting_date,
                DATE_TYPE_ENUM.ISO_DATE_STRAP
              )}
            />
            <RowText
              label={t("label_seed_class")}
              value={stringFormatting(data.plant_info?.seed_class)}
            />
            {status === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE && (
              <RowText
                label={t("label_hst")}
                value={stringFormatting(data.plant_info?.hst, "HST")}
              />
            )}
          </RowModule>
        </CardBody>
      </Card>
    )
  }

  const blockLocation = () => {
    return (
      <Card className={"mb-4"}>
        <CardBody className={"h-auto"}>
          <h4 className={"mb-8 text-uppercase"}>
            {loading ? (
              <Skeleton animation={"wave"} variant={"text"} height={32} width={200} />
            ) : (
              t("label_block_tag")
            )}
          </h4>
          <div className={"h-map-detail w-full p-4 mb-0"}>
            {data.block_location?.areas?.length > 0 && (
              <PriviewMap
                centroid={data.block_location?.centroid}
                areas={data.block_location?.areas}
                legend={data.block_location?.legend}
                legendTitle={t("label_land_status_information")}
                withStatus={true}
                infoStyle={mapInformationStyle}
                stroke={"#ffffff"}
              />
            )}
          </div>
        </CardBody>
      </Card>
    )
  }

  return (
    <>
      {blockDetail()}
      {plantInformation()}
      {blockLocation()}
    </>
  )
}